import { createRuntimeRemotesPlugin } from '@fe-toolkit/utility/modern/client'

/**
 * Runtime plugin that resolves fe-common's URL at runtime from env vars, so this build
 * can be deployed to any environment (dev/tst/stg/prd) without rebuild.
 *
 * All the URL-derivation logic lives in @fe-toolkit; this file just wires up the
 * remote-name → env-var mapping for this MFE.
 */
export default createRuntimeRemotesPlugin({
  remotes: {
    fe_common: {
      publicEnvVar: 'FE_COMMON_REMOTE',
      serverEnvVar: 'SERVER_FE_COMMON_REMOTE',
    },
  },
})
